import { Dimensions } from 'react-native';


export const { width, height } = Dimensions.get('window');

export const LARGURA_AREA_CONTEUDO = width>=1600?"50%":width>=1366?"60%":"80%";

export const LARGURA_AREA_CONTEUDO_PX = width>=1600?parseInt(width*0.5):width>=1366?parseInt(width*0.6):parseInt(width*0.8);

export const NOME_APP = "b2negocia";

export const TIPO_AMB_DEV = "DEV";
export const TIPO_AMB_PROD = "PROD";

export const MSG_ERRO_PADRAO = "Um erro ocorreu, por favor, tente novamente em alguns minutos.";


export const TIPO_LOGIN_NORMAL = 1;
export const TIPO_LOGIN_GOOGLE = 2;

export const ITEM_TIPO_PRODUTO = 1;
export const ITEM_TIPO_SERVICO = 2;

export const TIPO_NOTIF_PPT_NOVA = 7;
export const TIPO_NOTIF_CHAT_NOVA = 17;
export const TIPO_NOTIF_PDDO_CANCEL = 27;
export const TIPO_NOTIF_PRPTA_CANCEL = 37;
export const TIPO_NOTIF_PRPTA_ALTER = 47;
export const TIPO_NOTIF_MELHOR_LANCE = 57;
export const TIPO_NOTIF_CAI_POSI_LANCE = 67;
export const TIPO_NOTIF_PDDO_FINAL = 77;
export const TIPO_NOTIF_MELHOR_LANCE_FINAL = 87;
export const TIPO_NOTIF_EMAIL_VERIFICADO = 97;
export const TIPO_NOTIF_PDDO_PROXI_ENCERRA = 107;	

export const QUANT_MAX_FOTOS_PRODUTOS = 3;

export const TIPO_CAMERA_PERFIL = "perfil";
export const TIPO_CAMERA_ITEM = "item";
export const TIPO_CAMERA_PEDIDO= "pedido";

export const USER_TIPO_PF = 1;
export const USER_TIPO_PJ = 2;

export const PEDIDO_SITUACAO_ATIVO = 1;
export const PEDIDO_SITUACAO_CANCELADO = 0;
export const PEDIDO_SITUACAO_CONCLUIDO = 2;

export const ITEM_PROPOSTA_TIPO_PRODUTO = 1;
export const ITEM_PROPOSTA_TIPO_SERVICO = 2;

export const ITEM_PROPOSTA_ORIGEM_PEDIDO = 1;
export const ITEM_PROPOSTA_ORIGEM_PROPOSTA = 2;

export const EDR_TIPO_RESIDENCIAL = 7;
export const EDR_TIPO_COMERCIAL = 17;
export const EDR_TIPO_COBRANCA = 27;

export const TRANSACAO_TIPO_CREDITO = 1;
export const TRANSACAO_TIPO_DEBITO = 2;

export const ITEM_ANUNCIO_ATIVO = 1;
export const ITEM_ANUNCIO_INATIVO = 0;

export const ITEM_ATIVO = 1;
export const ITEM_INATIVO = 0;

export const TRANSACAO_NATUREZA_CREDITO_AVULSO = 3;

export const PRIVILEGIO_NENHUM = 0;
export const PRIVILEGIO_GESTOR = 1;
export const PRIVILEGIO_ADMIN = 2;

export const TIPO_TEMP_PEDDO_DISPO = 7;
export const TIPO_TEMP_OFERTAS = 17;

export const TELA_LOGIN = "login";
export const TELA_PRINCIPAL = "principal";
export const TELA_NOVO_USUARIO = "novoUsuario";
export const TELA_DETALHE_USUARIO = "detalheUsuario";
export const TELA_NOVO_ITEM = "novoItem";
export const TELA_MEUS_ITENS = "meusItens";
export const TELA_DETALHE_ITEM = "detalheItem";
export const TELA_ANUNCIO = "anuncio";
export const TELA_MEUS_PEDIDOS = "meusPedidos";
export const TELA_DETALHE_PEDIDO = "detalhePedido";
export const TELA_NOVO_PEDIDO = "novoPedido";
export const TELA_MINHAS_PROPOSTAS = "minhasPropostas";
export const TELA_NOVA_PROPOSTA = "novaProposta";
export const TELA_DETALHE_PROPOSTA = "detalheProposta";
export const TELA_CATEGORIA = "categorias";
export const TELA_SUBCATEGORIA = "subcategorias";
export const TELA_BUSCAR_PEDIDOS = "buscarPedidos";
export const TELA_BUSCAR_ITENS = "buscarItens";
export const TELA_LOJA = "loja";
export const TELA_LOJA_EXTERNO = "lojaExterno";
export const TELA_MEUS_ENDERECOS = "meusEnderecos";
export const TELA_FINANCEIRA = "financeiro";
export const TELA_PROPOSTAS_MEU_PEDIDO = "propostasMeuPedido";
export const TELA_CHAT = "chat";
export const TELA_NOVA_DENUNCIA = "novaDenuncia";
export const TELA_DENUNCIAS = "denuncias";

export const DNC_TIPO_RELACAO_USUARIO = 1;
export const DNC_TIPO_RELACAO_ITEM = 2;
export const DNC_TIPO_SERVICO_PEDIDO = 3;
export const DNC_TIPO_SERVICO_PROPOSTA = 4;
export const DNC_TIPO_SERVICO_MENSAGEM = 5;

export const TAM_MAX_IMAGEM = 1 * 1024 * 1024; //1MB
export const DESCRICAO_TAM_MAX_IMAGEM = "1MB";

export const UFs = [
    { id: 'AC', nome: 'Acre' }, 
    { id: 'AL', nome: 'Alagoas' }, 
    { id: 'AP', nome: 'Amapá' }, 
    { id: 'AM', nome: 'Amazonas' }, 
    { id: 'BA', nome: 'Bahia' }, 
    { id: 'CE', nome: 'Ceará' }, 
    { id: 'DF', nome: 'Distrito Federal' }, 
    { id: 'ES', nome: 'Espírito Santo' }, 
    { id: 'GO', nome: 'Goiás' }, 
    { id: 'MA', nome: 'Maranhão' }, 
    { id: 'MT', nome: 'Mato Grosso' }, 
    { id: 'MS', nome: 'Mato Grosso do Sul' }, 
    { id: 'MG', nome: 'Minas Gerais' }, 
    { id: 'PA', nome: 'Pará' }, 
    { id: 'PB', nome: 'Paraíba' }, 
    { id: 'PR', nome: 'Paraná' }, 
    { id: 'PE', nome: 'Pernambuco' }, 
    { id: 'PI', nome: 'Piauí' }, 
    { id: 'RJ', nome: 'Rio de Janeiro' }, 
    { id: 'RN', nome: 'Rio Grande do Norte' }, 
    { id: 'RS', nome: 'Rio Grande do Sul' }, 
    { id: 'RO', nome: 'Rondônia' }, 
    { id: 'RR', nome: 'Roraima' }, 
    { id: 'SC', nome: 'Santa Catarina' }, 
    { id: 'SP', nome: 'São Paulo' }, 
    { id: 'SE', nome: 'Sergipe' }, 
    { id: 'TO', nome: 'Tocantins' }]
	
export const MESES = [
    { id: '1', nome: 'Janeiro'}, 
    { id: '2', nome: 'Fevereiro' }, 
    { id: '3', nome: 'Março' }, 
    { id: '4', nome: 'Abril' }, 
    { id: '5', nome: 'Maio' }, 
    { id: '6', nome: 'Junho' }, 
    { id: '7', nome: 'Julho' }, 
    { id: '8', nome: 'Agosto' }, 
    { id: '9', nome: 'Setembro' }, 
    { id: '10', nome: 'Outubro' }, 
    { id: '11', nome: 'Novembro' }, 
    { id: '12', nome: 'Dezembro'}]